<template>
  <section class="cta-section">
    <div class="cta-content">
      <div class="text-content">
        <div class="badge">AI-Powered Lecture Platform</div>
        <h1 class="cta-title">
          <span class="title-line">글로벌 교육의 미래</span>
          <span class="title-line title-highlight">AITRA와 함께하세요</span>
        </h1>
        <p class="cta-subtitle">
          실시간 AI 번역으로 언어의 장벽 없이<br>
          전 세계 학생들과 함께하는 온라인 강의 플랫폼
        </p>
      </div>
      <div class="button-group">
        <router-link to="/login" class="btn btn-primary">
          <span class="btn-content">
            <i class="fas fa-arrow-right"></i>
            <span class="btn-text">시작하기</span>
          </span>
          <span class="btn-shine"></span>
        </router-link>
        <router-link to="/signup" class="btn btn-secondary">
          <span class="btn-content">
            <i class="fas fa-user-plus"></i>
            <span class="btn-text">무료 체험</span>
          </span>
        </router-link>
      </div>
      <div class="features-preview">
        <div class="feature-item">
          <i class="fas fa-graduation-cap"></i>
          <span>글로벌 강의</span>
        </div>
        <div class="feature-item">
          <i class="fas fa-language"></i>
          <span>160+ 언어 지원</span>
        </div>
        <div class="feature-item">
          <i class="fas fa-brain"></i>
          <span>AI 학습 지원</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// 파티클 스타일은 AnimatedBackground 컴포넌트에서 처리
</script>

<style scoped>
.cta-section {
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  overflow: hidden;
  background: transparent; /* 공통 배경 사용 */
}

/* 배경 관련 CSS는 AnimatedBackground 컴포넌트에서 처리 */

/* 콘텐츠 영역 */
.cta-content {
  position: relative;
  z-index: 2;
  max-width: 1000px;
  width: 100%;
  text-align: center;
  animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.text-content {
  margin-bottom: 3.5rem;
}

/* 배지 */
.badge {
  display: inline-block;
  padding: 0.5rem 1.25rem;
  background: rgba(146, 205, 220, 0.15);
  border: 1px solid rgba(146, 205, 220, 0.3);
  border-radius: 50px;
  color: #92CDDC;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 2rem;
  backdrop-filter: blur(10px);
}

/* 타이틀 */
.cta-title {
  font-size: 4rem;
  font-weight: 800;
  color: #FFFFFF;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.title-line {
  display: block;
}

.title-highlight {
  background: linear-gradient(135deg, #FFFFFF 0%, #92CDDC 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 서브타이틀 */
.cta-subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
  line-height: 1.8;
  max-width: 700px;
  margin: 0 auto;
}

/* 버튼 그룹 */
.button-group {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

/* 버튼 스타일 - 수정된 부분 */
.btn {
  position: relative;
  padding: 1.25rem 3rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  text-decoration: none;
  overflow: hidden;
  border: 2px solid transparent;
  flex: 1;
  min-width: 0;
}

.btn-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
}

.btn-content i {
  font-size: 0.875rem;
  transition: transform 0.3s ease;
}

.btn-text {
  font-size: 0.9375rem;
  white-space: nowrap;
}

/* Primary 버튼 */
.btn-primary {
  background: linear-gradient(135deg, #FFFFFF 0%, #F5F5F5 100%);
  color: #0033A0;
  box-shadow: 0 8px 24px rgba(255, 255, 255, 0.15);
}

.btn-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s ease;
  z-index: 1;
}

.btn-primary:hover .btn-shine {
  left: 100%;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(255, 255, 255, 0.25);
}

.btn-primary:hover .btn-content i {
  transform: translateX(4px);
}

/* Secondary 버튼 */
.btn-secondary {
  background: rgba(255, 255, 255, 0.05);
  color: #FFFFFF;
  border: 2px solid rgba(146, 205, 220, 0.4);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.btn-secondary:hover {
  background: rgba(146, 205, 220, 0.15);
  border-color: rgba(146, 205, 220, 0.6);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(146, 205, 220, 0.2);
}

.btn-secondary:hover .btn-content i {
  transform: scale(1.1);
}

/* 기능 미리보기 */
.features-preview {
  display: flex;
  justify-content: center;
  gap: 3rem;
  flex-wrap: wrap;
  padding-top: 2rem;
  border-top: 1px solid rgba(146, 205, 220, 0.2);
  max-width: 800px;
  margin: 0 auto;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  font-weight: 500;
}

.feature-item i {
  color: #92CDDC;
  font-size: 1.25rem;
}

/* 반응형 디자인 */
@media (max-width: 1024px) {
  .cta-title {
    font-size: 3rem;
  }

  .cta-subtitle {
    font-size: 1.125rem;
  }

  .gradient-orb {
    filter: blur(100px);
  }
}

@media (max-width: 768px) {
  .cta-section {
    padding: 3rem 1.5rem;
  }

  .cta-title {
    font-size: 2.25rem;
  }

  .cta-subtitle {
    font-size: 1rem;
  }

  .button-group {
    flex-direction: column;
    gap: 1rem;
  }

  .btn {
    width: 100%;
    max-width: 300px;
  }

  .features-preview {
    gap: 2rem;
  }

  .feature-item {
    font-size: 0.875rem;
  }

  .particle {
    display: none;
  }

  .wave-pattern {
    opacity: 0.1;
  }

  .rotating-rings {
    display: none;
  }
}

@media (max-width: 480px) {
  .cta-title {
    font-size: 1.875rem;
  }

  .cta-subtitle {
    font-size: 0.9375rem;
  }

  .badge {
    font-size: 0.75rem;
    padding: 0.375rem 1rem;
  }

  .text-content {
    margin-bottom: 2.5rem;
  }

  .features-preview {
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }

  .gradient-orb {
    filter: blur(60px);
    opacity: 0.3;
  }
}
</style> 